import { fetchWithTimeout } from "@/utils";
export const sendClassifiedAnalytics = async (analyticsUrl, data) => {
    try {
        const response = await fetchWithTimeout(analyticsUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        if (!response.ok) {
            console.log("Failed to send classified analytics view. Response: ", response);
        }
    }
    catch (error) {
        console.log("Failed to send classified analytics view");
    }
    return {};
};
